/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Load_CalendarsInputs */

const en_settings_load_calendars = /** @type {(inputs: Settings_Load_CalendarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load my calendars`)
};

const he_settings_load_calendars = /** @type {(inputs: Settings_Load_CalendarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טען את היומנים שלי`)
};

/**
* | output |
* | --- |
* | "Load my calendars" |
*
* @param {Settings_Load_CalendarsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_load_calendars = /** @type {((inputs?: Settings_Load_CalendarsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Load_CalendarsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_load_calendars(inputs)
	return he_settings_load_calendars(inputs)
});